import type {Thread} from '@github-ui/diff-lines/conversation-types'
import {ThreadGroupVariant, getThreadAuthor, ThreadGroupVariantLabels} from '../util/classify-thread'
import {getThreadFileLabel} from '../util/thread-file-label'
import {CommentIdentity} from '../shared/CommentIdentity'
import styles from './ThreadTitle.module.css'
import {ThreadBadges} from './ThreadBadges'

function ThreadMessage({variant}: {variant: ThreadGroupVariant}) {
  return <span>&nbsp;{ThreadGroupVariantLabels[variant] || 'commented'}</span>
}

export function ThreadTitle({thread, variant}: {thread: Thread; variant: ThreadGroupVariant}) {
  const message = <ThreadMessage variant={variant} />

  // Falls back to the ghost user (login `ghost`, profile `/ghost`) when the
  // comment author no longer exists, matching the expanded thread view.
  const author = getThreadAuthor(thread, variant)

  // When the thread is code-anchored, show the file name (and lines) inline in the
  // header. The full file path is shown only once the item is expanded.
  const fileLabel = getThreadFileLabel(thread)

  return (
    <span className={styles.ThreadTitle}>
      <CommentIdentity login={author.login} linkable={author.linkable} />
      {message}
      {fileLabel.hasFile ? (
        <>
          <span aria-hidden="true" className={styles.middot}>
            ·
          </span>
          <span className={styles.fileName}>{fileLabel.fileName}</span>
        </>
      ) : null}
      <ThreadBadges isResolved={thread.isResolved} isOutdated={thread.isOutdated} className={styles.badges} />
    </span>
  )
}
